// Export types
export type { Feature, FeatureCategory } from './types';

// Import all feature categories
import { resourcesFeatures } from './categories/resources';
import { dashboardFeatures } from './categories/dashboard';
import { homeSafetyFeatures } from './categories/homeSafety';
import { progressFeatures } from './categories/progress';
import { healthMonitoringFeatures } from './categories/healthMonitoring';
import { dailyLivingFeatures } from './categories/dailyLiving';
import { socialNetworkFeatures } from './categories/socialNetwork';
import { activitiesFeatures } from './categories/activities';
import { artsCultureFeatures } from './categories/artsCulture';
import { chatCompanionsFeatures } from './categories/chatCompanions';
import { familyGuidesFeatures } from './categories/familyGuides';
import { integrationsFeatures } from './categories/integrations';

// Add-on feature lists (displayed as section headers, not columns)
import { proLevelCareToolsFeatures } from './categories/proLevelCareTools';
import { professionalContextFeatures } from './categories/professionalContext';

// Core feature categories (3-column comparison: Limited Access, Essential, Family)
export const featureCategories = [
  dashboardFeatures,
  homeSafetyFeatures,
  progressFeatures,
  healthMonitoringFeatures,
  integrationsFeatures,
  dailyLivingFeatures,
  socialNetworkFeatures,
  activitiesFeatures,
  artsCultureFeatures,
  chatCompanionsFeatures,
  familyGuidesFeatures,
  resourcesFeatures
];

// Add-on feature sections (displayed vertically with badges, not as columns)
export const addOnFeatureSections = {
  thriveCare: {
    title: "Care Team Professional Tools",
    subtitle: "Designed for professional caregivers and care teams.",
    badge: "Available with Care Team",
    features: [
      'Care visit documentation',
      'Voice notes',
      'Client reporting summaries',
      'Task tracking',
      'Family communication tools',
      'Compliance-ready documentation',
      ...professionalContextFeatures.features.map(f => f.name)
    ]
  }
};
